import React from 'react';
import { Row } from '../../../lib/utils';
import { Body3Regular } from '../../../lib/font';
import { colors } from '../../../lib/colors';

interface AgreementCheckboxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: string;
}

const AgreementCheckbox: React.FC<AgreementCheckboxProps> = ({
    checked,
    onChange,
    label = '위 안내 내용을 모두 확인하고 동의합니다',
}) => {
    return (
        <Row
            onClick={() => onChange(!checked)}
            style={{
                width: '100%',
                padding: '16px 20px',
                backgroundColor: '#FFFFFF',
                borderRadius: 12,
                border: checked ? `1.5px solid ${colors.primary}` : '1.5px solid #E0E0E0',
                cursor: 'pointer',
                alignItems: 'center',
                gap: 12,
                transition: 'border-color 0.2s',
            }}
        >
            <div
                style={{
                    width: 24,
                    height: 24,
                    borderRadius: 12,
                    backgroundColor: checked ? colors.primary : '#FFFFFF',
                    border: checked ? 'none' : '2px solid #D0D0D0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    transition: 'all 0.2s',
                }}
            >
                {checked && (
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M3 7l3 3 5-6" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                )}
            </div>
            <Body3Regular style={{ color: checked ? colors.LAVEL_4 : colors.LAVEL_2 }}>
                {label}
            </Body3Regular>
        </Row>
    );
};

export default AgreementCheckbox;
